import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ba8ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "title fs-4 fs-lg-4 text-center" }
const _hoisted_3 = { class: "title fs-4 fs-lg-4 text-center mb-3 mb-lg-5" }
const _hoisted_4 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_5 = { class: "fw-bold fs-6 text-center mb-5" }
const _hoisted_6 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_7 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_8 = { class: "w-max-content col-lg-3" }
const _hoisted_9 = { class: "mx-0 col-lg-6 text-break" }
const _hoisted_10 = {
  key: 0,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_11 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_12 = { class: "w-max-content col-lg-3" }
const _hoisted_13 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_14 = {
  key: 2,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_15 = { class: "w-max-content col-lg-3" }
const _hoisted_16 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_17 = {
  key: 3,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_18 = { class: "w-max-content col-lg-3" }
const _hoisted_19 = { class: "mx-0 col-lg-2" }
const _hoisted_20 = { class: "mx-0 col-lg-1" }
const _hoisted_21 = { class: "mx-0 col-lg-2" }
const _hoisted_22 = {
  key: 4,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_23 = { class: "w-max-content col-lg-3" }
const _hoisted_24 = { class: "mx-0 col-lg-4" }
const _hoisted_25 = {
  key: 5,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_26 = { class: "w-max-content col-lg-3" }
const _hoisted_27 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_28 = {
  key: 6,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_29 = { class: "w-max-content col-lg-3" }
const _hoisted_30 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_31 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_32 = {
  key: 7,
  class: "fw-bold mb-4 fs-6 p-2"
}
const _hoisted_33 = {
  key: 8,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_34 = { class: "w-max-content col-lg-3" }
const _hoisted_35 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_36 = {
  key: 9,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_37 = { class: "w-max-content col-lg-3" }
const _hoisted_38 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_39 = {
  key: 10,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_40 = { class: "w-max-content col-lg-3" }
const _hoisted_41 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_42 = {
  key: 11,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_43 = { class: "w-max-content col-lg-3" }
const _hoisted_44 = { class: "mx-0 col-lg-2" }
const _hoisted_45 = { class: "mx-0 col-lg-1" }
const _hoisted_46 = { class: "mx-0 col-lg-2" }
const _hoisted_47 = {
  key: 12,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_48 = { class: "w-max-content col-lg-3" }
const _hoisted_49 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_50 = {
  key: 13,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_51 = { class: "w-max-content col-lg-3" }
const _hoisted_52 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_53 = {
  key: 14,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_54 = { class: "w-max-content col-lg-3" }
const _hoisted_55 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_56 = { class: "mx-0 col-lg-4 text-break" }
const _hoisted_57 = {
  key: 15,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_58 = {
  key: 16,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_59 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_60 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_61 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_62 = {
  key: 17,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_63 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_64 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_65 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_66 = {
  key: 18,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_67 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_68 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_69 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_70 = {
  key: 19,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_71 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_72 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_73 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_74 = {
  key: 20,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_75 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_76 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_77 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_78 = { class: "bg-white container my-5 shadow rounded-4 p-3 p-lg-5 mb-3 mb-lg-5" }
const _hoisted_79 = { class: "fw-bold fs-6" }
const _hoisted_80 = { class: "row pb-5" }
const _hoisted_81 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_82 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { REGISTER_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { computed, watchEffect, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { getAdditionalInformationDisplayData, removeAlumniIdx, removeAlumniIdxArray } from '@/utils'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const loadingButton = ref<boolean>(false)
const ID = 'SA20'

const data = computed(() => store.getters[REGISTER_STORE.GETTERS.REGISTER_COMMUNITY_VALUE])
const inviteData = computed(() => store.getters[REGISTER_STORE.GETTERS.INVITE])
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const termsCommunity = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_COMMUNITY])
const invalid = computed(() => store.getters[REGISTER_STORE.GETTERS.GET_VALIDATE_POST_COMMUNITY])
const isErrorAdditionInformation = ref(false)
const communityRequiredDataOld = ref(null)
const checkConfirm = localStorage.getItem('checkConfirm')

const fetchRegisterAlumnusCommunityData = async () => {
  if (inviteData.value?.community_id) {
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, inviteData.value?.community_id)
  }
}

watchEffect(() => {
  if (!checkConfirm) {
    router.push({ path: '/alumni/register_alumnus_community', query: { invited_code: route.query?.invited_code } })
  }
  window.addEventListener('unload', function () {
    localStorage.removeItem('checkConfirm')
  })
})
const backRegis = () => {
  router.push({ path: '/alumni/register_alumnus_community', query: { invited_code: route.query?.invited_code } })
  localStorage.removeItem('checkConfirm')
  localStorage.setItem('backToEditRegis', true)
}

const transitComplete = async (): void => {
  loadingButton.value = true
  try {
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_VALIDATE_POST_COMMUNITY, {
      invited_code: route.query?.invited_code,
      version_of_community: termsCommunity.value.id,
      consent_of_community: data.value.consent_of_community,
      alumni_community_informations: {
        display_name: data.value.display_name,
        corporation_organization_name: data.value.corporation_organization_name,
        corporation_department_name: data.value.corporation_department_name,
        corporation_start_period:
          communityRequiredData.value.corporation_start_period && data.value.corporation_start_period ? dayjs(data.value.corporation_start_period).format('YYYY/MM/DD') : null,
        corporation_end_period:
          communityRequiredData.value.corporation_end_period && data.value.corporation_end_period ? dayjs(data.value.corporation_end_period).format('YYYY/MM/DD') : null,
        corporation_employee_id: data.value.corporation_employee_id,
        corporation_email: data.value.corporation_email,
        corporation_family_name: data.value.corporation_family_name,
        corporation_given_name: data.value.corporation_given_name,
        school_organization_name: data.value.school_organization_name,
        school_faclty_name: data.value.school_faclty_name,
        school_department_name: data.value.school_department_name,
        school_start_period: communityRequiredData.value.school_start_period && data.value.school_start_period ? dayjs(data.value.school_start_period).format('YYYY/MM/DD') : null,
        school_end_period: communityRequiredData.value.school_end_period && data.value.school_end_period ? dayjs(data.value.school_end_period).format('YYYY/MM/DD') : null,
        school_student_id: data.value.school_student_id,
        school_email: data.value.school_email,
        school_family_name: data.value.school_family_name,
        school_given_name: data.value.school_given_name,
        additional_information_1_type: communityRequiredData.value.additional_information_1_setting?.type,
        additional_information_2_type: communityRequiredData.value.additional_information_2_setting?.type,
        additional_information_3_type: communityRequiredData.value.additional_information_3_setting?.type,
        additional_information_4_type: communityRequiredData.value.additional_information_4_setting?.type,
        additional_information_5_type: communityRequiredData.value.additional_information_5_setting?.type,
        additional_information_1: removeAlumniIdxArray(data.value.additional_information_1),
        additional_information_2: removeAlumniIdxArray(data.value.additional_information_2),
        additional_information_3: removeAlumniIdxArray(data.value.additional_information_3),
        additional_information_4: removeAlumniIdxArray(data.value.additional_information_4),
        additional_information_5: removeAlumniIdxArray(data.value.additional_information_5),
        //CHECK
      },
      community_id: inviteData.value?.community_id,
    })
    if (!invalid.value) {
      router.push('/alumni/register_alumnus_community_finished')
      store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_COMMUNITY_VALUE, {
        invited_code: '',
        display_name: '',
        corporation_organization_name: '',
        corporation_department_name: '',
        corporation_start_period: '',
        corporation_end_period: '',
        corporation_employee_id: '',
        corporation_email: '',
        corporation_family_name: '',
        corporation_given_name: '',
        school_organization_name: '',
        school_faculty_name: '',
        school_department_name: '',
        school_start_period: '',
        school_end_period: '',
        school_student_id: '',
        school_email: '',
        school_family_name: '',
        school_given_name: '',
        additional_information_1: '',
        additional_information_2: '',
        additional_information_3: '',
        additional_information_4: '',
        additional_information_5: '',
        consent_of_community: false,
        version_of_community: '',
      })
      // console.log('chay vao day 358', invalid)
    } else {
      // console.log('chay vao day 359', invalid)
      communityRequiredDataOld.value = communityRequiredData.value
      // console.log('registerAlumnusCommunityData ban dau: ', communityRequiredDataOld)
      if (invalid.value == 'ERROR_ADDITIONAL_INFORMATIONS') {
        isErrorAdditionInformation.value = true
        fetchRegisterAlumnusCommunityData()
        loadingButton.value = false
        // router.push({ path: '/alumni/register_alumnus_community', query: { invited_code: route.query?.invited_code } })
      } else {
        router.push({ path: '/alumni/register_alumnus_community', query: { invited_code: route.query?.invited_code } })
      }
    }
    localStorage.removeItem('checkConfirm')
    localStorage.setItem('checkSubmit', true)
  } catch (error) {
    console.log('err', error)
  }
}

watch(
  () => communityRequiredData,
  async () => {
    if (isErrorAdditionInformation.value) {
      // console.log('communityRequiredData ban dau 2: ', communityRequiredDataOld.value)
      // console.log('communityRequiredData luc sau2: ', communityRequiredData.value)

      var additional_information_1_new = data.value.additional_information_1
      var additional_information_2_new = data.value.additional_information_2
      var additional_information_3_new = data.value.additional_information_3
      var additional_information_4_new = data.value.additional_information_4
      var additional_information_5_new = data.value.additional_information_5
      if (communityRequiredDataOld?.value?.additional_information_1_setting?.type !== communityRequiredData.value.additional_information_1_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_1_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_1_new = []
        } else {
          additional_information_1_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_2_setting?.type !== communityRequiredData.value.additional_information_2_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_2_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_2_new = []
        } else {
          additional_information_2_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_3_setting?.type !== communityRequiredData.value.additional_information_3_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_3_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_3_new = []
        } else {
          additional_information_3_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_4_setting?.type !== communityRequiredData.value.additional_information_4_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_4_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_4_new = []
        } else {
          additional_information_4_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_5_setting?.type !== communityRequiredData.value.additional_information_5_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_5_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_5_new = []
        } else {
          additional_information_5_new = ''
        }
      }

      const newData = {
        ...data.value,
        additional_information_1: additional_information_1_new,
        additional_information_2: additional_information_2_new,
        additional_information_3: additional_information_3_new,
        additional_information_4: additional_information_4_new,
        additional_information_5: additional_information_5_new,
      }
      // console.log('newData', newData)
      store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_COMMUNITY_VALUE, newData)
      router.push({ path: '/alumni/register_alumnus_community', query: { invited_code: route.query?.invited_code } })
      isErrorAdditionInformation.value = false
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

const disableCorporation = (communityRequiredData: any) => {
  if (
    communityRequiredData?.corporation_organization_name == 0 &&
    communityRequiredData?.corporation_department_name == 0 &&
    communityRequiredData?.corporation_email == 0 &&
    communityRequiredData?.corporation_employee_id == 0 &&
    communityRequiredData?.corporation_end_period == 0 &&
    communityRequiredData?.corporation_family_name == 0 &&
    communityRequiredData?.corporation_given_name == 0 &&
    communityRequiredData?.corporation_start_period == 0
  ) {
    return true
  }
  return false
}
const disableSchool = (communityRequiredData: any) => {
  if (
    communityRequiredData?.school_organization_name === 0 &&
    communityRequiredData?.school_department_name === 0 &&
    communityRequiredData?.school_email === 0 &&
    communityRequiredData?.school_end_period === 0 &&
    communityRequiredData?.school_faclty_name === 0 &&
    communityRequiredData?.school_family_name === 0 &&
    communityRequiredData?.school_given_name === 0 &&
    communityRequiredData?.school_start_period === 0 &&
    communityRequiredData?.school_student_id === 0
  ) {
    return true
  }
  return false
}
const disableInformation = (communityRequiredData: any) => {
  if (
    communityRequiredData?.additional_information_1 === 0 &&
    communityRequiredData?.additional_information_2 === 0 &&
    communityRequiredData?.additional_information_3 === 0 &&
    communityRequiredData?.additional_information_4 === 0 &&
    communityRequiredData?.additional_information_5 === 0
  ) {
    return true
  }
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(inviteData).corporation_name) + " " + _toDisplayString(_unref(translate)('SA25headingFirst')), 1),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA26headingSecond')), 1),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translate)(`SA20titleComfirm`)), 1),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(translate)('basicInformation')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('nickName')), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(data).display_name), 1)
        ]),
        (!disableCorporation(_unref(communityRequiredData)))
          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_unref(translate)(`${ID}enrollment`)), 1))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).corporation_organization_name === 1 || _unref(communityRequiredData).corporation_organization_name === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)(`${ID}corporationOrganizationName`)), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(data).corporation_organization_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).corporation_department_name === 1 || _unref(communityRequiredData).corporation_department_name === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)(`${ID}department`)), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(data).corporation_department_name), 1)
            ]))
          : _createCommentVNode("", true),
        (
            (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1) ||
            (_unref(communityRequiredData).corporation_start_period === 2 && _unref(communityRequiredData).corporation_end_period === 2)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)(`${ID}enrollmentPeriod`)), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(data).corporation_start_period ? _unref(dayjs)(_unref(data).corporation_start_period).format('YYYY/MM') : ''), 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)('SA20from')), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(data).corporation_end_period ? _unref(dayjs)(_unref(data).corporation_end_period).format('YYYY/MM') : ''), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).corporation_employee_id === 1 || _unref(communityRequiredData).corporation_employee_id === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)(`${ID}employeeID`)), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(data).corporation_employee_id), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).corporation_email === 1 || _unref(communityRequiredData).corporation_email === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)(`${ID}emailEnrollment`)), 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(data).corporation_email), 1)
            ]))
          : _createCommentVNode("", true),
        (
            (_unref(communityRequiredData).corporation_family_name === 1 && _unref(communityRequiredData).corporation_given_name === 1) ||
            (_unref(communityRequiredData).corporation_family_name === 2 && _unref(communityRequiredData).corporation_given_name === 2)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)(`OE30nameAtTime`)), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(data).corporation_family_name), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(data).corporation_given_name), 1)
            ]))
          : _createCommentVNode("", true),
        (!disableSchool(_unref(communityRequiredData)))
          ? (_openBlock(), _createElementBlock("h3", _hoisted_32, _toDisplayString(_unref(translate)(`${ID}informationAtSchool`)), 1))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).school_organization_name === 1 || _unref(communityRequiredData).school_organization_name === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)(`${ID}schoolOrganizationName`)), 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(data).school_organization_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).school_faclty_name === 1 || _unref(communityRequiredData).school_faclty_name === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(translate)(`${ID}facultyName`)), 1),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(data).school_faclty_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).school_department_name === 1 || _unref(communityRequiredData).school_department_name === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(translate)(`${ID}departmentName`)), 1),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(data).school_department_name), 1)
            ]))
          : _createCommentVNode("", true),
        (
            (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1) ||
            (_unref(communityRequiredData).school_start_period === 2 && _unref(communityRequiredData).school_end_period === 2)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)(`${ID}periodOfEnrollment`)), 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(data).school_start_period ? _unref(dayjs)(_unref(data).school_start_period).format('YYYY/MM') : ''), 1),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(translate)(`${ID}from`)), 1),
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(data).school_end_period ? _unref(dayjs)(_unref(data).school_end_period).format('YYYY/MM') : ''), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).school_student_id === 1 || _unref(communityRequiredData).school_student_id === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(translate)(`${ID}studentID`)), 1),
              _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(data).school_student_id), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).school_email === 1 || _unref(communityRequiredData).school_email === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(translate)(`${ID}emailAttendSchool`)), 1),
              _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(data).school_email), 1)
            ]))
          : _createCommentVNode("", true),
        (
            (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1) ||
            (_unref(communityRequiredData).school_family_name === 2 && _unref(communityRequiredData).school_given_name === 2)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)(`${ID}nameAtSchool`)), 1),
              _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(data).school_family_name), 1),
              _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(data).school_given_name), 1)
            ]))
          : _createCommentVNode("", true),
        (!disableInformation(_unref(communityRequiredData)))
          ? (_openBlock(), _createElementBlock("h3", _hoisted_57, _toDisplayString(_unref(translate)(`${ID}additionalInformation`)), 1))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).additional_information_1 === 1 || _unref(communityRequiredData).additional_information_1 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(communityRequiredData).additional_information_1_question), 1),
              (_unref(communityRequiredData).additional_information_1_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_1), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(data)?.additional_information_1), 1))
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).additional_information_2 === 1 || _unref(communityRequiredData).additional_information_2 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(communityRequiredData).additional_information_2_question), 1),
              (_unref(communityRequiredData).additional_information_2_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_2), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_unref(data)?.additional_information_2), 1))
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).additional_information_3 === 1 || _unref(communityRequiredData).additional_information_3 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(communityRequiredData).additional_information_3_question), 1),
              (_unref(communityRequiredData).additional_information_3_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_3), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_unref(data)?.additional_information_3), 1))
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).additional_information_4 === 1 || _unref(communityRequiredData).additional_information_4 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(communityRequiredData).additional_information_4_question), 1),
              (_unref(communityRequiredData).additional_information_4_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_4), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_unref(data)?.additional_information_4), 1))
            ]))
          : _createCommentVNode("", true),
        (_unref(communityRequiredData).additional_information_5 === 1 || _unref(communityRequiredData).additional_information_5 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("label", _hoisted_75, _toDisplayString(_unref(communityRequiredData).additional_information_5_question), 1),
              (_unref(communityRequiredData).additional_information_5_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_5), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_unref(data)?.additional_information_5), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("h1", _hoisted_79, _toDisplayString(_unref(translate)('consent')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createVNode(Button, {
            title: _unref(translate)('titleButtonEdit'),
            type: 'secondary',
            onClick: backRegis
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createVNode(Button, {
            title: _unref(translate)('titleRegis'),
            type: 'secondary',
            loading: loadingButton.value,
            disabled: loadingButton.value,
            onClick: transitComplete
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ], 32)
  ]))
}
}

})